import React from 'react'
import { Link } from 'react-router-dom'
import Sliders from './sliders'
import imagen1 from '../Componentes/sliders/slider1/imagen1.jpg'
import imagen2 from '../Componentes/sliders/slider1/imagen2.jpg'
import imagen3 from '../Componentes/sliders/slider1/imagen3.jpg'
import imagen4 from '../Componentes/sliders/slider1/imagen4.jpg'
import imagen5 from '../Componentes/sliders/slider1/imagen5.jpg'
import imagen6 from '../Componentes/sliders/slider1/imagen6.jpg'
import imagen7 from '../Componentes/sliders/slider1/imagen7.jpg'
import imagen8 from '../Componentes/sliders/slider1/imagen8.jpg'
import imagen9 from '../Componentes/sliders/slider1/imagen9.jpg'
import imagen10 from '../Componentes/sliders/slider1/imagen10.jpg'
import imagen11 from '../Componentes/sliders/slider2/imagen11.jpg'
import imagen12 from '../Componentes/sliders/slider2/imagen12.jpg'
import imagen13 from '../Componentes/sliders/slider2/imagen13.JPG'
import imagen14 from '../Componentes/sliders/slider2/imagen14.JPG'
import imagen15 from '../Componentes/sliders/slider2/imagen15.jpg'
import imagen16 from '../Componentes/sliders/slider2/imagen16.jpg'
import imagen17 from '../Componentes/sliders/slider2/imagen17.jpg'
import imagen18 from '../Componentes/sliders/slider2/imagen18.jpg'
import imagen19 from '../Componentes/sliders/slider2/imagen19.jpg'
import imagen20 from '../Componentes/sliders/slider2/imagen20.jpg'
import imagen21 from '../Componentes/sliders/slider2/imagen21.jpg'
import imagen22 from '../Componentes/sliders/slider2/imagen22.jpg'
import imagen23 from '../Componentes/sliders/slider2/imagen23.jpg'
import imagen24 from '../Componentes/sliders/slider2/imagen24.jpg'
import imagen25 from '../Componentes/sliders/slider2/imagen25.jpg'
import imagen26 from '../Componentes/sliders/slider3/imagen26.jpg'
import imagen27 from '../Componentes/sliders/slider3/imagen27.jpg'
import imagen28 from '../Componentes/sliders/slider3/imagen28.jpg'
import imagen29 from '../Componentes/sliders/slider3/imagen29.jpg'
import imagen30 from '../Componentes/sliders/slider3/imagen30.jpg'
import imagen31 from '../Componentes/sliders/slider3/imagen31.jpg'
import imagen32 from '../Componentes/sliders/slider3/imagen32.jpg'
import imagen33 from '../Componentes/sliders/slider3/imagen33.jpg'
import imagen34 from '../Componentes/sliders/slider3/imagen34.jpg'
import imagen35 from '../Componentes/sliders/slider3/imagen35.jpg'
import imagen36 from '../Componentes/sliders/slider3/imagen36.jpg'
import imagen37 from '../Componentes/sliders/slider3/imagen37.jpg'
import imagen38 from '../Componentes/sliders/slider4/imagen38.jpg'
import imagen39 from '../Componentes/sliders/slider4/imagen39.jpg'
import imagen40 from '../Componentes/sliders/slider4/imagen40.jpg'
import imagen41 from '../Componentes/sliders/slider4/imagen41.jpg'
import imagen42 from '../Componentes/sliders/slider4/imagen42.jpg'
import imagen43 from '../Componentes/sliders/slider4/imagen43.jpg'
import imagen44 from '../Componentes/sliders/slider4/imagen44.jpg'
import imagen45 from '../Componentes/sliders/slider4/imagen45.jpg'
import imagen46 from '../Componentes/sliders/slider4/imagen46.jpg'
import imagen47 from '../Componentes/sliders/slider4/imagen47.jpg'
import imagen48 from '../Componentes/sliders/slider4/imagen48.jpg'
import imagen49 from '../Componentes/sliders/slider4/imagen49.jpg'
import imagen50 from '../Componentes/sliders/slider4/imagen50.jpg'
import imagen51 from '../Componentes/sliders/slider4/imagen51.jpg'
import imagen52 from '../Componentes/sliders/slider4/imagen52.jpg'
import imagen53 from '../Componentes/sliders/slider4/imagen53.jpg'
import imagen54 from '../Componentes/sliders/slider4/imagen54.jpg'
import imagen55 from '../Componentes/sliders/slider4/imagen55.jpg'
import imagen56 from '../Componentes/sliders/slider4/imagen56.jpg'
import imagen57 from '../Componentes/sliders/slider4/imagen57.jpg'
import imagen58 from '../Componentes/sliders/slider4/imagen58.jpg'
import imagen59 from '../Componentes/sliders/slider4/imagen59.jpg'
import imagen60 from '../Componentes/sliders/slider4/imagen60.jpg'
import imagen61 from '../Componentes/sliders/slider4/imagen61.jpg'
import imagen62 from '../Componentes/sliders/slider4/imagen62.jpg'
import imagen63 from '../Componentes/sliders/slider4/imagen63.jpg'
import imagen64 from '../Componentes/sliders/slider4/imagen64.jpg'
import imagen65 from '../Componentes/sliders/slider4/imagen64.jpg'
import imagen66 from '../Componentes/sliders/slider4/imagen66.jpg'
import imagen67 from '../Componentes/sliders/slider4/imagen67.jpg'
import imagen68 from '../Componentes/sliders/slider4/imagen68.jpg'
import imagen69 from '../Componentes/sliders/slider4/imagen69.jpg'



let imagenesMx = [
  imagen1,
  imagen2,
  imagen3,
  imagen4,
  imagen5,
  imagen6,
  imagen7,
  imagen8,
  imagen9,
  imagen10,
]

let imagenes3300 = [
  imagen11,
  imagen12,
  imagen13,
  imagen14,
  imagen15,
  imagen16,
  imagen17,
  imagen18,
  imagen19,
  imagen20,
  imagen21,
  imagen22,
  imagen23,
  imagen24,
  imagen25,
  
]

let imagenesMP = [
  imagen26,
  imagen27,
  imagen28,
  imagen29,
  imagen30,
  imagen31,
  imagen32,
  imagen33,
  imagen34,
  imagen35,
  imagen36,
  imagen37, 
]

let imagenesRep = [
  imagen38,
  imagen39,
  imagen40,
  imagen41,
  imagen42,
  imagen43,
  imagen44,
  imagen45,
  imagen46,
  imagen47,
  imagen48,
  imagen49,
  imagen50,
  imagen51,
  imagen52,
  imagen53,
  imagen54,
  imagen55,
  imagen56,
  imagen57,
  imagen58,
  imagen59,
  imagen60,
  imagen61,
  imagen62,
  imagen63,
  imagen64,
  imagen65,
  imagen66,
  imagen67,
  imagen68,
  imagen69,
]



export const Inicio = () => {
  return (
    <div className='home'>
        <h1>
            Hola, soy Oswaldo Gonzalez Ingeniero en electronica con mas de 10 años de 
            experiencia en ascensores, actualmente estudiando desarrollo web
        </h1>

        <h2>
            Realizo trabajos en ascensores multimarca como: mantenimientos,
            soluciones de averias, reparaciones, normalizaciones de equipos, programacion de mantenimientos, manejo de personal, redaccion de informes, visitas tecnicas  <Link to="/contacto">Contacta conmigo</Link>
        </h2>

        <section className='lasts-works'>
            <h2 className='heading'>Algunos de mis trabajos</h2>
            <p style={{ textAlign: 'center' }}>Estos son algunos de mis trabajos como tecnico de ascensores</p>


            
            <div className='works'>
            
              
              <Sliders 
                  titulo="Modernizacion MX" 
                  imagenes={imagenesMx} />

              <Sliders 
                  titulo="Instalacion 3300"
                  imagenes={imagenes3300} />

              <Sliders 
                  titulo="Instalacion MP Hidraulico"
                  imagenes={imagenesMP} />

              <Sliders 
                  titulo="Reparaciones y Normalizaciones"
                  imagenes={imagenesRep} />
            </div>

        </section>
    </div>
  )
}
